var exports = {
  "WB": "DMWelcomeSection.module__welcomeSection___Mi1jZD",
  "rZ": "DMWelcomeSection.module__profileSection___Mi1jZD",
  "KI": "DMWelcomeSection.module__avatarButton___Mi1jZD",
  "xO": "DMWelcomeSection.module__usernameButton___Mi1jZD",
  "Xh": "DMWelcomeSection.module__username___Mi1jZD",
  "Yh": "DMWelcomeSection.module__welcomeText___Mi1jZD",
  "A2": "DMWelcomeSection.module__actionSection___Mi1jZD",
  "I9": "DMWelcomeSection.module__mutualGuildsContainer___Mi1jZD",
  "Ko": "DMWelcomeSection.module__guildIconWrapper___Mi1jZD",
  "$f": "DMWelcomeSection.module__guildIcon___Mi1jZD",
  "Ii": "DMWelcomeSection.module__mutualGuildsText___Mi1jZD",
  "fc": "DMWelcomeSection.module__actionButtonsContainer___Mi1jZD",
};

module.exports = exports;
